import React, { useState } from "react";
import { Grid, Button } from "@material-ui/core";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import { _t } from "js/utils/TranslationService";

export const FacturaZoomViewer = ({
  facturaUrl,
  facturaUrls,
  abrirImagenEnNuevaPestana
}) => {
  const urls = (facturaUrls && facturaUrls.length
    ? facturaUrls
    : [facturaUrl]
  ).filter(Boolean);
  const [activeIndex, setActiveIndex] = useState(0);
  const activeUrl = urls[activeIndex] || urls[0];

  if (!activeUrl) {
    return (
      <Grid item xs={12} style={{ minHeight: "480px" }}>
        {_t("No hay imagen de factura disponible.")}
      </Grid>
    );
  }

  return (
    <Grid
      item
      xs={12}
      style={{
        height: "480px",
        maxWidth: "640px",
        overflow: "hidden",
        border: "1px solid #e0e0e0",
        position: "relative",
        borderRadius: "4px"
      }}
    >
      <TransformWrapper
        key={activeUrl}
        initialScale={1}
        minScale={1}
        limitToBounds={true}
        wheel={{ disabled: false }}
        panning={{ disabled: false }}
        doubleClick={{ disabled: true }}
      >
        {({ zoomIn, zoomOut, resetTransform }) => (
          <>
            <TransformComponent
              wrapperStyle={{
                width: "100%",
                height: "100%",
                display: "grid",
                placeItems: "center"
              }}
              contentStyle={{
                width: "100%",
                height: "100%",
                display: "grid",
                placeItems: "center"
              }}
            >
              <div
                style={{ position: "relative", width: "100%", height: "100%" }}
              >
                <img
                  src={activeUrl}
                  alt={_t("Factura")}
                  style={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    cursor: "grab"
                  }}
                />
              </div>
            </TransformComponent>

            {/* Controles */}
            <div style={{ position: "absolute", bottom: 20, right: 20 }}>
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: "0.5em" }}
                onClick={() => zoomIn()}
              >
                +
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: "0.5em" }}
                onClick={() => zoomOut()}
              >
                -
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => resetTransform()}
              >
                Reset
              </Button>
            </div>

            {/* Botón de descarga */}
            <div style={{ position: "absolute", top: 20, right: 20 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => abrirImagenEnNuevaPestana(activeUrl)}
              >
                <DownloadIcon />
              </Button>
            </div>
          </>
        )}
      </TransformWrapper>
      {urls.length > 1 && (
        <div
          style={{
            position: "absolute",
            bottom: 75,
            left: 10,
            right: 10,
            display: "flex",
            gap: 8,
            overflowX: "auto"
          }}
        >
          {urls.map((url, index) => (
            <button
              type="button"
              key={url}
              onClick={() => setActiveIndex(index)}
              style={{
                border:
                  index === activeIndex
                    ? "2px solid #ff9800"
                    : "1px solid #ddd",
                padding: 2,
                background: "white",
                cursor: "pointer"
              }}
            >
              <img
                src={url}
                alt={`${_t("Factura")} ${index + 1}`}
                style={{ height: 48, maxWidth: 72 }}
              />
            </button>
          ))}
        </div>
      )}
    </Grid>
  );
};
